import { render, staticRenderFns } from "./EmojiInputBox.vue?vue&type=template&id=156e6b6e"
import script from "./EmojiInputBox.vue?vue&type=script&lang=js"
export * from "./EmojiInputBox.vue?vue&type=script&lang=js"
import style0 from "./EmojiInputBox.vue?vue&type=style&index=0&id=156e6b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports